import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const YearTag = ({ year, position }) => {
    const theme = useTheme();

    return (
        <Box
            sx={(t) => ({
                position: 'absolute',
                top: 0,
                left: position === 'left' ? 40 : 'unset',
                right: position === 'right' ? 40 : 'unset',
                padding: '8px 18px',
                background: 'linear-gradient(89.51deg, #E15C12 0.42%, #FCB336 101.32%)',
                borderRadius: '30px',
                [t.breakpoints.down('md')]: {
                    left: '50%',
                    right: 'unset',
                    padding: '4px 12px',
                    transform: 'translateX(-50%)'
                }
            })}
        >
            <Typography
                sx={(t) => ({
                    fontSize: '24px',
                    fontWeight: 500,
                    color: '#FFFFFF',
                    [t.breakpoints.down('md')]: {
                        fontSize: '12px'
                    }
                })}
            >
                {year}
            </Typography>
        </Box>
    );
};

export default YearTag;
